module.exports = __webpack_public_path__ + "img/SealcoatTruck.b73864d9.png";